import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Anchor from '../../../commonComponents/Anchor';
import translate from '../../../commonComponents/translate';

function ReportBtnTab(props) {
  const { isActive, label, link } = props;

  const classes = cx('report-tab-btn', isActive && 'report-tab-btn-active');
  return (
    <Anchor href={link} className={classes}>
      {label}
    </Anchor>
  );
}

ReportBtnTab.propTypes = {
  isActive: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
};

export default translate(ReportBtnTab);
